/* eslint-disable jsx-a11y/anchor-is-valid */
import { useEffect, useState } from "react";
import { Switch, Redirect } from "react-router-dom";
import { toAbsoluteUrl } from "../../../../_metronic/_helpers";
import { ContentRoute, LayoutSplashScreen } from "../../../../_metronic/layout";
import { getNoticePermissionsData, getPasswordSetData, getSchool } from "../_redux/authCrud";
import "../../../../_metronic/_assets/sass/pages/login/classic/login-1.scss";
import Login from "./Login";
import OtpVerification from "./OtpVerification";
import ForgotPassword from "./ForgotPassword"
import UsernameAndPasswordSet from "./UsernameAndPasswordSet";
import NoticePermissionsSet from "./NoticePermissionsSet";

export function AuthPage() {
  const [showSplashScreen, setShowSplashScreen] = useState(true);
  const [authData, setAuthData] = useState({});  

  const getAndSetAuthData = async () => {
    let result;
    //const domain = window.location.hostname === "localhost" ? "demogm.eduway.site" : window.location.hostname;
    const domain = window.location.hostname === "localhost" ? "demookulu.eduway.site" : window.location.hostname;
    //const domain = window.location.hostname === "localhost" ? "bdkolejetlik.eduway.site" : window.location.hostname;
    const path1 = window.location.pathname.split("/")[1];
    if (path1 === "kullanici-adi-ve-sifre-belirleme") result = await getPasswordData(domain);
    else if (path1 === "duyuru-izinleri-belirleme") result = await getPermissionsData();
    else result = await getSchool(domain);
    result.data.entity.domain = domain;
    setAuthData(result.data.entity);
  };

  const getPasswordData = async domain => {
    const passwordSetData = {
      domain,
      token: window.location.pathname.split("/")[2]
    };
    return await getPasswordSetData(passwordSetData)
  }

  const getPermissionsData = async () => {
    const permissionData = {
      userType: parseInt(window.location.pathname.split("/")[2]),
      personId: window.location.pathname.split("/")[3],
      schoolId: window.location.pathname.split("/")[4],
      userId: window.location.pathname.split("/")[5]
    };
    return await getNoticePermissionsData(permissionData);
  };

  useEffect(() => {
    getAndSetAuthData().then(() => setShowSplashScreen(false));
  }, []);
  
  return (
    showSplashScreen ? 
    <LayoutSplashScreen /> 
    :
    <>
      <div className="d-flex flex-column flex-root">
        {/*begin::Login*/}
        <div
          className="login login-1 login-signin-on d-flex flex-column flex-lg-row flex-column-fluid bg-white"
          id="kt_login"
        >
          {/*begin::Aside*/}
          <div
            className="login-aside d-flex flex-row-auto bgi-size-cover bgi-no-repeat p-10 p-lg-10"
            style={{
              backgroundImage: `url(${toAbsoluteUrl("/media/bg/phone4.png")})`,
              maxWidth: "800px"
            }}
          >
            {/*begin: Aside Container*/}
            <div className="d-flex flex-row-fluid flex-column justify-content-between">
              {/* start:: Aside header */}
              <div className="flex-column-auto mt-5 pb-lg-0 pb-10">
                {/* <img
                  alt="Logo"
                  className="max-h-70px"
                  src={toAbsoluteUrl("/media/logos/logo-letter-1.png")}
                /> */}
              </div>
              {/* end:: Aside header */}

              {/* start:: Aside footer for desktop */}
              <div className="d-none flex-column-auto d-lg-flex justify-content-between mt-10">
                <div className="opacity-70 font-weight-bold">
                  &copy; 2025 - {new Date().getFullYear()} Okul Uygulaması
                </div>
                <div className="d-flex">
                  <a href="http://www.eduweb.site/hakkimizda" target="blank">
                    Hakkımızda
                  </a>
                  <a href="http://www.eduweb.site/eduwiser-okul-yonetim-yazilimi" target="blank" className="ml-10">
                    Modüllerimiz
                  </a>
                  <a href="http://www.eduweb.site/iletisim" target="blank" className="ml-10">
                    İletişim
                  </a>
                </div>
              </div>
              {/* end:: Aside footer for desktop */}
            </div>
            {/*end: Aside Container*/}
          </div>
          {/*begin::Aside*/}

          {/*begin::Content*/}
          <div className="d-flex flex-column flex-row-fluid position-relative p-7 overflow-hidden">
            {/* begin::Content body */}
            <div className="d-flex flex-column-fluid flex-center mt-30 mt-lg-0">
              <Switch>
                <ContentRoute path="/giris-yap" component={() => <Login authData={authData} />} />
                <ContentRoute path="/otp-dogrulama" component={() => <OtpVerification authData={authData} />} />
                <ContentRoute path="/sifremi-unuttum" component={() => <ForgotPassword authData={authData} />} />
                <ContentRoute path="/kullanici-adi-ve-sifre-belirleme/:id" component={() => <UsernameAndPasswordSet authData={authData} />} />
                <ContentRoute path="/duyuru-izinleri-belirleme/:userType/:id" component={() => <NoticePermissionsSet authData={authData} />} />
                <Redirect from="/auth" exact={true} to="/giris-yap" />
                <Redirect to="/giris-yap" />
              </Switch>
            </div>
            {/*end::Content body*/}

            {/* begin::Mobile footer */}
            <div className="d-flex d-lg-none flex-column-auto flex-column flex-sm-row justify-content-between align-items-center mt-5 p-5">
              <div className="text-dark-50 font-weight-bold order-2 order-sm-1 my-2">
                &copy; 2025 - {new Date().getFullYear()} Okul Uygulaması
              </div>
              <div className="d-flex order-1 order-sm-2 my-2">
                <a href="http://www.edu.com.tr/hakkimizda" target="blank" className="text-dark-75 text-hover-primary">
                  Hakkımızda
                </a>
                <a
                  href="http://www.edu.com.tr/eduwiser-okul-yonetim-yazilimi"
                  target="blank"
                  className="text-dark-75 text-hover-primary ml-4"
                >
                  Modüllerimiz
                </a>
                <a
                  href="http://www.edu.com.tr/iletisim"
                  target="blank"
                  className="text-dark-75 text-hover-primary ml-4"
                >
                  İletişim
                </a>
              </div>
            </div>
            {/* end::Mobile footer */}
          </div>
          {/*end::Content*/}
        </div>
        {/*end::Login*/}
      </div>
    </>
  );
}